import React from "react";
import {
  Flame, Building2, Mountain, Truck, Factory, Droplets, Wind,
  Warehouse, Headset, Globe2, BadgeCheck, Siren, Scissors, ReceiptText, MapPin,
} from "lucide-react";

const MAP = {
  Flame, Building2, Mountain, Truck, Factory, Droplets, Wind,
  Warehouse, Headset, Globe2, BadgeCheck, Siren, Scissors, ReceiptText, MapPin,
};

export const IndustryIcon = ({ name, className }) => {
  const Cmp = MAP[name] || Factory;
  return <Cmp className={className} />;
};
